import React from 'react';

import Hero from './Hero/Hero';
import Info from './Info/Info';

const Home = () => (
  <>
    <Hero />
    <Info />
  </>
);

export default Home;
